import {Component, OnInit, Output, EventEmitter, OnDestroy} from '@angular/core';
import {VetClinic} from "../../models/vet-clinic.model";
import {Client} from "../../models/client.model";
import {OrderSettlement} from "../../models/order-settlement.model";
import {GenericActionComponent} from "../generic-action.component";
import {SummarySettlement} from "../../models/summary-settlements.model";
import {CommonUtils} from "../../utils/common";
import {FormBuilder, Validators} from "@angular/forms";
import {SettlementsReportsService} from "../../providers/settlements-reports.service";
import {ModalController, ToastController} from "@ionic/angular";
import {UserService} from "../../providers/user.service";
import {AppStateService} from "../../providers/app-state.service";
import {TranslateService} from "@ngx-translate/core";
import {OrderSettlementService} from "../../providers/order-settlement.service";
import {ClientsService} from "../../providers/clients.service";
import {SummarySettlementDtoRequest} from "../../models/summary-settlement-dto-request.model";
import {Subscription} from "rxjs";
import {FileService} from "../../providers/file.service";

@Component({
  selector: 'app-process-settlement-report',
  templateUrl: './process-settlement-report.component.html',
  styleUrls: ['./process-settlement-report.component.scss'],
})
export class ProcessSettlementReportComponent extends GenericActionComponent implements OnInit, OnDestroy {
  clients: Client[];
  clientUUID: string;
  clinics: VetClinic[];
  isBusy: boolean;
  settlements: OrderSettlement[];
  @Output() reportAddedEmitter = new EventEmitter<SummarySettlement>();
  @Output() reportAddedCancelEmitter = new EventEmitter<Boolean>();
  private vetclinicId: number;
  private settlementsUUIDs: string[];
  private cliientsSub: Subscription;
  private settlementSub: Subscription;
  private clinicSub: Subscription;


  constructor(
    public commonUtils : CommonUtils,
    private formBuilder: FormBuilder,
    private settlementsReportsService: SettlementsReportsService,
    private toastController: ToastController,
    private userService: UserService,
    private settlementService: OrderSettlementService,
    private clientService: ClientsService,
    private appStateService: AppStateService,
    private modalController: ModalController,
    private translateService: TranslateService,
  ) {
    super(commonUtils, appStateService, modalController, translateService);
  }

  ngOnInit() {
    // this.settlementsUUIDs = [];
    this.formGroup = this.formBuilder.group({
      clientUUID: ['', Validators.required],
      vetcodeId: ['', Validators.required]
    });

    super.ngOnInit();
    this.userService.getUser().subscribe(u => this.user = u);
    this.cliientsSub = this.clientService.listAllClients().subscribe(e => {
      if (e !== null) {
        this.clients = e;
      }
    })
  }


  onAdd() {
    this.commonUtils.presentYesNoActionSheet('Na pewno chcesz zarejestrować nowy raport rozliczeniowyy?', 'Tak', 'Nie', 'checkmark', 'close', () => {
      this.appStateService.updateIsBusySubject(true);
      let summarySettlementDtoRequest: SummarySettlementDtoRequest = this.commonUtils.formGroupValuesToObject<SummarySettlementDtoRequest>(new SummarySettlementDtoRequest(), this.formGroup);
      // summarySettlementDtoRequest.setttlements = this.settlementsUUIDs;

      console.log(summarySettlementDtoRequest);

      this.settlementsReportsService.prepareNewSummarySettlement(summarySettlementDtoRequest)
        .subscribe((summarySettlement: SummarySettlement) => {
            if (summarySettlement && summarySettlement.uuid) {
              this.commonUtils.presentInfoToast("Raport został utworzony").then(res => {
                this.reportAddedEmitter.emit(summarySettlement);
              });
              this.formGroup.reset();
              this.appStateService.updateIsBusySubject(false);
            } else {
              this.commonUtils.presentAlertToast("Wystąpił błąd podczas tworzenia raportu");
              this.appStateService.updateIsBusySubject(false);
            }
          },
          error => {
            this.commonUtils.presentAlertToast("Wystąpił błąd podczas tworzenia raportu");
            this.appStateService.updateIsBusySubject(false);
          });
    }, () => {
    });
  }


  onChoseClient($event: CustomEvent) {
    this.appStateService.updateIsBusySubject(true);
    this.clientUUID = $event.detail.value;
    this.clinicSub = this.settlementService.showAllAvailableClinicsWithNotSettleSettlementsForClient(this.clientUUID).subscribe(c => {
      this.appStateService.updateIsBusySubject(false);
      this.clinics = c;
    }, error => {
      this.appStateService.updateIsBusySubject(false);
    });
    this.markUnsavedChanges();
  }

  onChoseClinic($event) {
    this.appStateService.updateIsBusySubject(true);
    this.vetclinicId = $event.detail.value;
    this.settlementSub = this.settlementService.showAllNotSettledSettlementForClinic($event.detail.value).subscribe(s => {
      this.appStateService.updateIsBusySubject(false);
      this.settlements = s;
    }, error => {
      this.appStateService.updateIsBusySubject(false);
    });
    this.markUnsavedChanges();
  }

  isFormFull(): boolean {
    return this.formGroup.valid && (this.clientUUID !== '' && this.vetclinicId !== undefined);
  }

  addToSettlements(settlement: OrderSettlement) {
    if (this.settlementsUUIDs.filter(e => e === settlement.uuid).length === 1) {
      this.settlementsUUIDs = this.settlementsUUIDs.filter(e => e !== settlement.uuid)
    } else {
      this.settlementsUUIDs.push(settlement.uuid);
    }
  }


  ngOnDestroy() {
    super.ngOnDestroy();
    if (this.cliientsSub) {
      this.cliientsSub.unsubscribe();
    }
    if (this.settlementSub) {
      this.settlementSub.unsubscribe();
    }
    if (this.clinicSub) {
      this.clinicSub.unsubscribe();
    }
  }
}
